import * as ContainerQueries from '@tailwindcss/container-queries';
import { Config } from 'tailwindcss';
import { themeConfigBase } from '../base/config';
import { theme } from './config';

export const twPreset: Config = {
  content: [],
  theme: {
    ...theme,
    ...themeConfigBase,
  },
  plugins: [
    ContainerQueries,
  ],
};
